export enum DeviceOrigin {
  mobileApp = 'mobile-app',
  web = 'web',
}
